import React, {useEffect, useState} from 'react'
import {Button, Form, Grid, Header, Menu, Input, Segment, Table, Icon, Label} from "semantic-ui-react";
import Axios from "axios";
import {useHistory} from "react-router-dom";
import objDefault from '../../../models/homeModel'
import {
    DatesRangeInput
} from 'semantic-ui-calendar-react';
import Constants from "../../../config/constants";
import moment from "moment";
import {staff_search} from "../../../config/staff";
import {reactLocalStorage} from "reactjs-localstorage";

const Home = () => {
    const history = useHistory()
    const [input, setInput] = useState({
        ...objDefault
    });
    const [users, setUsers] = useState([]);

    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))
    };

    function openInNewTab(id, path) {
        var win = window.open(path + id, '_blank');
        win.focus();
    }

    const navigateTo = (id, path) => {
        history.push(path + id);
    }

    const navigateToBasket = (fullPath) => {
        history.push(fullPath);
    }

    const navigateToBasketBlank = (fullPath) => {
        var win = window.open(fullPath, '_blank');
        win.focus();
    }

    const navigateToAdmission = (path) => {
        history.push(path);
    }
    useEffect(() => {

        search()

    }, []);

    const getPatients = async () => {
        let result = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/list', {
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            }
        )

        setUsers(result.data.data);

        result = result.data
        setInput((prevInput) => ({
            ...prevInput,
            pageSize: result.pageSize,
            page: result.page,
            pageTotal: result.pageTotal,
            recordTotal: result.recordTotal,
        }))
    }

    const softDelete = async (id) => {
        if (window.confirm("ยืนยันลบรายการ")) {
            await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/list-delete?admission_id=' + id,
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            )

            setUsers([])
            let result = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/list?name=' + input.name + '&staff_id=' + input.staff_id + '&hn=' + input.hn + '&page=',
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            )
            setUsers(result.data.data);

        }
    }

    const setPagination = () => {
        let row = []
        for (let i = 0; i <= input.pageTotal; i++) {
            if(i !== input.pageTotal) {
                row.push(<Menu.Item as='a'
                                    onClick={() => search(i + 1)}
                                    key={i}
                >{i + 1}</Menu.Item>)
            }
        }

        return row
    }

    const search = async (page = 1) => {

        try {
            setUsers([])
            let result = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/list?name=' + input.name + '&staff_id=' + input.staff_id + '&admission_range=' + input.admission_range + '&discharge_range=' + input.discharge_range + '&hn=' + input.hn + '&page=' + page,
                {
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            )
            setUsers(result.data.data);
            result = result.data
            setInput((prevInput) => ({
                ...prevInput,
                pageSize: result.pageSize,
                page: result.page,
                pageTotal: result.pageTotal,
                recordTotal: result.recordTotal,
            }))
        } catch (e) {
            console.log(e);
        }
    }
    return (
        <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>

            <div style={{flex: 1}}>

                <Grid style={{marginTop: "5em", marginLeft: "2em"}}>
                    <Grid.Row>
                        <Grid.Column width={15}>
                            <Segment color='teal' raised>
                                <Header as='h3' block>
                                    ค้นหาข้อมูล

                                </Header>

                                <Form>
                                    <Grid.Column>
                                        <Form.Group widths='equal'>

                                            <Form.Field

                                                control={Input}
                                                name='hn'
                                                label='HN'
                                                placeholder='HN'
                                                onChange={(e) => handleValueChange(e)}
                                            />
                                            <Form.Field

                                                control={Input}
                                                name='name'
                                                label='ชื่อ-นามสกุลคนไข้'
                                                placeholder='ชื่อ-นามสกุล'
                                                onChange={(e) => handleValueChange(e)}
                                            />

                                            <Form.Select

                                                fluid label='ชื่ออาจารย์'
                                                name='staff_id'
                                                value={input.staff_id}
                                                options={staff_search}
                                                placeholder='ชื่ออาจารย์'
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                                required={'true'}

                                            />

                                            <DatesRangeInput
                                                label='ช่วงเวลา admission'
                                                name="admission_range"
                                                placeholder="From - To"
                                                value={input.admission_range}
                                                iconPosition="left"
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                            />
                                            <DatesRangeInput
                                                label='ช่วงเวลา discharge'
                                                name="discharge_range"
                                                placeholder="From - To"
                                                value={input.discharge_range}
                                                iconPosition="left"
                                                onChange={(e, {name, value}) => handleValueChange({
                                                    target: {
                                                        name,
                                                        value
                                                    }
                                                })}
                                            />


                                        </Form.Group>
                                    </Grid.Column>
                                </Form>
                                <Grid centered>
                                    <Grid.Column/>
                                    <Grid.Row centered columns={4}>
                                        <Grid.Column/>
                                        <Button icon primary
                                                onClick={() => search()}
                                        >
                                            <Icon name='search'/> ค้นหา
                                        </Button>
                                        <Button basic icon color='green' content='Green'
                                                onClick={() => navigateToAdmission('/admission')}>
                                            <Icon name='plus circle'/> new admission note
                                        </Button>
                                        <Grid.Column/>
                                    </Grid.Row>
                                </Grid>


                            </Segment>

                        </Grid.Column>

                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={15}>
                            <Segment color='teal' raised>

                                <Table celled structured>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell rowSpan='2'>#</Table.HeaderCell>
                                            <Table.HeaderCell rowSpan='2' style={{width:'180px'}}>ชื่อ</Table.HeaderCell>
                                            <Table.HeaderCell rowSpan='2'>HN</Table.HeaderCell>
                                            <Table.HeaderCell rowSpan='2'>AN</Table.HeaderCell>
                                            <Table.HeaderCell rowSpan='2' style={{width:'160px'}}>อาจารย์</Table.HeaderCell>
                                            <Table.HeaderCell rowSpan='2'>Principal diagnosis</Table.HeaderCell>
                                            <Table.HeaderCell rowSpan='2' style={{width:'120px'}}>Admission date</Table.HeaderCell>
                                            <Table.HeaderCell rowSpan='2' style={{width:'120px'}}>Discharge date</Table.HeaderCell>
                                            <Table.HeaderCell
                                                colSpan={reactLocalStorage.get('username') == 'admin' ? '6' : '5'}
                                                style={{textAlign: 'center'}}>ดำเนินการ</Table.HeaderCell>
                                        </Table.Row>
                                        <Table.Row>
                                            <Table.HeaderCell style={{width:'120px'}}>Admission note</Table.HeaderCell>
                                            <Table.HeaderCell style={{width:'160px'}}>Discharge summary</Table.HeaderCell>
                                            <Table.HeaderCell style={{width:'100px'}}>VTE</Table.HeaderCell>
                                            <Table.HeaderCell style={{width:'120px'}}>Operative note</Table.HeaderCell>
                                            <Table.HeaderCell>Picture</Table.HeaderCell>
                                            {reactLocalStorage.get('username') == 'admin' ?
                                                <Table.HeaderCell>Action</Table.HeaderCell> : ''}

                                        </Table.Row>

                                    </Table.Header>


                                    <Table.Body>
                                        {

                                            users.map((user, index) => (
                                                <Table.Row>
                                                    <Table.Cell>{index + 1}</Table.Cell>
                                                    <Table.Cell>{user.fullname}</Table.Cell>
                                                    <Table.Cell>{user.hn}</Table.Cell>
                                                    <Table.Cell>{user.an}</Table.Cell>
                                                    <Table.Cell>{user.staff_id ? staff_search.find(item => item.key === user.staff_id).text : ''}</Table.Cell>
                                                    <Table.Cell>{user.principal_diagnosis}</Table.Cell>
                                                    <Table.Cell>{user.admission_date ? moment(user.admission_date).format("DD-MM-YYYY") : null}</Table.Cell>
                                                    <Table.Cell>{user.discharge_date ? moment(user.discharge_date).format("DD-MM-YYYY") : null}</Table.Cell>
                                                    <Table.Cell>
                                                        <Button size='mini' icon color='teal'
                                                                onClick={(e) => navigateTo(user.admission_id, '/admission?id=')}
                                                                key={user.admission_id}><Icon
                                                            name="check circle outline"></Icon></Button>

                                                        <Button size='mini' icon color='red'
                                                                onClick={() => openInNewTab(user.admission_id, '/admission/pdf?id=')}
                                                                key={user.admission_id}> <Icon
                                                            name='file pdf'/></Button>
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {user.dc_status ?
                                                            <>
                                                                <Button size='mini' icon color='teal'
                                                                        onClick={() => navigateTo(user.admission_id, '/discharge?admission_id=')}
                                                                        key={user.discharge_id}><Icon
                                                                    name="check circle outline"></Icon></Button>
                                                                <Button size='mini' icon color='red'
                                                                        onClick={() => openInNewTab(user.discharge_id, '/discharge/pdf?discharge_id=')}
                                                                        key={user.discharge_id}> <Icon name='file pdf'/></Button>
                                                            </>
                                                            :
                                                            <Button size='mini' icon color='grey'
                                                                    onClick={() => navigateTo(user.admission_id, '/discharge?admission_id=')}
                                                                    key={user.admission_id}><Icon
                                                                name="circle outline"></Icon></Button>
                                                        }


                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <Button size='mini' icon color={user.vte_assessment_status ? 'teal':'grey'}
                                                                onClick={() => navigateToBasket( `/vte?admission_id=${user.admission_id}&patient_id=${user.patient_id}&admission_date=${user.admission_date}&state=${user.vte_assessment_status}`)}
                                                                key={user.admission_id}><Icon
                                                            name={user.vte_assessment_status ?'check circle outline':'circle outline'}></Icon>
                                                        </Button>
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {user.op_note_status ?
                                                            <>
                                                                <Button size='mini' icon color='teal'
                                                                        onClick={() => navigateTo(user.admission_id, '/opnote?admission_id=')}
                                                                        key={user.admission_id}><Icon
                                                                    name="check circle outline"></Icon> {user.op_note_status}
                                                                </Button>
                                                            </>
                                                            :
                                                            <Button size='mini' icon color='grey'
                                                                    onClick={() => navigateTo(user.admission_id, '/opnote?admission_id=')}
                                                                    key={user.admission_id}><Icon
                                                                name="circle outline"></Icon></Button>
                                                        }


                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {user.basket_status ?
                                                            <>
                                                                <Button size='mini' icon color='teal'
                                                                        onClick={() => navigateToBasketBlank(`/basket?admission_id=${user.admission_id}&patient_id=${user.patient_id}`)}
                                                                        key={user.patient_id}><Icon
                                                                    name="check circle outline"></Icon> {user.basket_status}
                                                                </Button>
                                                            </>
                                                            :
                                                            <Button size='mini' icon color='grey'
                                                                    onClick={() => navigateToBasketBlank(`/basket?admission_id=${user.admission_id}&patient_id=${user.patient_id}`)}
                                                                    key={user.patient_id}><Icon
                                                                name="circle outline"></Icon></Button>
                                                        }


                                                    </Table.Cell>
                                                    {
                                                        reactLocalStorage.get('username') == 'admin' ?
                                                            <>
                                                                <Table.Cell>


                                                                    <Button size='mini' icon color='red'
                                                                            onClick={() => softDelete(user.admission_id)}
                                                                            key={user.patient_id}><Icon
                                                                        name="delete"></Icon>
                                                                    </Button>


                                                                </Table.Cell>
                                                            </>
                                                            : ''
                                                    }

                                                </Table.Row>
                                            ))
                                        }
                                    </Table.Body>

                                    <Table.Footer>
                                        <Table.Row>
                                            <Table.HeaderCell
                                                colSpan={reactLocalStorage.get('username') == 'admin' ? '13' : '12'}>
                                                <Menu floated='left' pagination>
                                                    <Menu.Item as='a' icon>
                                                        <Icon name='chevron left'/>
                                                    </Menu.Item>

                                                    {
                                                        <>

                                                            {setPagination()}

                                                        </>
                                                    }
                                                    <Menu.Item as='a' icon>
                                                        <Icon name='chevron right'/>
                                                    </Menu.Item>
                                                </Menu>
                                            </Table.HeaderCell>
                                        </Table.Row>

                                    </Table.Footer>
                                </Table>
                            </Segment>

                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>

        </div>
    );
}

export default Home;
